import React from 'react';
import { DiscountDto, DiscountDtoTypeEnum } from '@coretava/api/ecommerce-service';
import { Trans } from '@gamiphy/react-i18n';
import { formatDate } from '@gamiphy/utils/date';
import { formatDiscountValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { WheelStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers/wheel';

export const useDiscountDescription = (discount: DiscountDto): React.ReactNode => {
  const optionName = React.useMemo(
    () => WheelStore.wheel?.wheelOptions.find((option) => option.id === discount.reference?.wheelOptionId)?.name,
    [WheelStore.wheel, discount],
  );

  return React.useMemo(() => {
    switch (discount?.type) {
      case DiscountDtoTypeEnum.FreeShipping:
        return (
          <Trans
            i18nKey="campaigns.boosters.wheel.congrats.freeShipping.info"
            defaults="You've unlocked <strong>Free Shipping</strong> on your next order <strong>over {{minRedemptionValue, currency}}</strong>! 🚚✨<br/>No extra costs—just shop and enjoy.<br/>Offer expires on {{expiryDate}}. Hurry up!"
            values={{
              expiryDate: discount.expiresAt && formatDate(discount.expiresAt),
              minPurchaseAmount: discount.cashbackConfig.minRedemptionValue,
            }}
          />
        );
      case DiscountDtoTypeEnum.FreeSku:
        return (
          <Trans
            i18nKey="campaigns.boosters.wheel.congrats.Sku.info"
            defaults="You've unlocked a <strong>FREE {{skuName}}!</strong><br/>Add it to your cart, spend <strong>over {{minRedemptionValue, currency}}</strong>, and enjoy your reward.<br/>Offer expires on {{expiryDate}}. Hurry up!"
            values={{
              expiryDate: discount.expiresAt && formatDate(discount.expiresAt),
              skuName: optionName,
              minRedemptionValue: discount.cashbackConfig.minRedemptionValue,
            }}
          />
        );
      case DiscountDtoTypeEnum.Monetary:
      case DiscountDtoTypeEnum.Percentage:
        return (
          <Trans
            i18nKey="campaigns.boosters.survey.discountReceived"
            defaults="You've received a <strong>{{discount}} discount</strong> on your next order. Offer expires on <strong>{{expiryDate}}. Hurry up!</strong>"
            values={{
              discount: formatDiscountValue(discount),
              expiryDate: discount.expiresAt && formatDate(discount.expiresAt),
            }}
          />
        );
      default:
        return undefined;
    }
  }, [discount, optionName]);
};
